import {
  RewardListPageKey,
  RewardModalKey,
  RewardSellingModalKey,
  StatusTextKey,
  VoucherCodeSetupPageKey
} from '../../TModules';

export const translations = {
  [RewardListPageKey]: {
    Reward: 'Récompense',
    List: 'Liste',
    All: 'Tout',
    Draft: 'Brouillon',
    Pending: 'En attente',
    Scheduled: 'Programmé',
    Active: 'Actif',
    Ended: 'Terminé',
    Inactive: 'Inactif',
    TransactionIssued: 'Transaction émise',
    Private: 'Privé',
    System: 'Système',
    SellingFast: 'Vente rapide',
    SoldOut: 'Épuisé',
    Subtitle: 'Sous-titre',
    Stackable: 'Empilable',

    Name: 'Nom',
    Merchant: 'Marchand',
    Status: 'Statut',
    Balance: 'Solde',
    RedemptionBalance: 'Solde de rachat',
    RewardRedeemed: 'Utilisé',
    VoidedReward: 'Annulé',
    SellingFrom: 'Vente à partir de',
    SellingTo: "Vente jusqu'à",
    Actions: 'Actions',
    RequestType: 'Type de demande',
    Comments: 'Commentaires',
    LastUpdated: 'Dernière mise à jour',

    CreateNew: 'Créer nouveau',
    Edit: 'Modifier',
    DownloadCodes: 'Télécharger les codes',
    DuplicateReward: 'Dupliquer la récompense',
    Deactivate: 'Désactiver',
    Activate: 'Activer',
    DownloadDepletedCodes: 'Télécharger les codes épuisés',
    UnassginedVouchers: 'Bons non attribués',
    ReplinishVouchers: 'Reconstituer les bons',
    Deplete: 'Épuiser',
    Replinish: 'Reconstituer',
    AppendBudget: 'Ajouter un budget',
    Approve: 'Approuver',
    RequestDeletion: 'Demander la suppression',
    PublishNew: 'Publier nouveau',
    Reactivate: 'Réactiver',
    NA: 'N.A',

    Type: 'Type',
    RewardName: 'Nom de la récompense',
    Description: 'Description',
    StepsToRedeem: 'Étapes pour racheter',
    SellingPeriod: 'Période de vente',
    ActiveAt: 'Actif à',
    TermsAndConditions: 'Termes et conditions',
    RiskDisclaimer: 'Avertissement de risque',
    BrandName: 'Nom de la marque',
    Brands: 'Marques',
    Tags: 'Tags',
    Categories: 'Catégories',
    Labels: 'Étiquettes',
    Catalogues: 'Catalogues',
    UploadedPhotos: 'Photos téléchargées',
    UploadedPhoto: 'Photo téléchargée',
    UploadMultipleImages: 'Télécharger plusieurs images',
    UploadAFile: 'Télécharger un fichier',
    WhereCanThisbeRewardDisplayed: 'Où cette récompense peut-elle être affichée',
    RewardCost: 'Coût de la récompense',
    SellingPrice: 'Prix de vente',
    CustomFields: 'Champs personnalisés',

    AudienceInfo: "Informations sur l'audience",
    AudienceAttributes: "Attributs de l'audience",
    AudienceList: "Liste d'audience",
    NoFiltersSelected: 'Aucun filtre sélectionné',
    NoListSelected: 'Aucune liste sélectionnée',

    RewardsMechanics: 'Mécanismes de récompense',
    CodeType: 'Type de code',
    Code: 'Code',
    VoucherCodeType: 'Type de code de bon',
    RewardIssuanceLimit: "Limite d'émission de récompense",
    TotalRedemptionLimit: 'Limite totale de rachat',
    RedemptionLimitsPerPeriod: 'Limites de rachat par période',
    RewardIssuancePerPeriodLimit: "Limite d'émission de récompense par période",
    UserLimits: 'Limites utilisateur',
    UserLimitsPerPeriod: 'Limites utilisateur par période',
    VoucherValidity: 'Validité du bon',
    RedemptionType: 'Type de rachat',
    GiftingOption: 'Option de cadeau',

    Public: 'Public',
    MainBodyText: 'Texte principal',
    AddAccordion: 'Ajouter un accordéon',

    Next: 'Suivant',
    Cancel: 'Annuler',
    Browse: 'Parcourir',
    Back: 'Retour',
    SaveAsDraft: 'Enregistrer comme brouillon',
    Launch: 'Lancer',
    Publish: 'Publier',
    Save: 'Enregistrer',
    PerIssuance: 'Par émission',
    ConversionMetric: 'Métrique de conversion',
    CostPerIssued: 'Coût par émission',
    BudgetAllocation: 'Allocation de budget',
    Inventory: 'Inventaire',
    ActivationDate: "Date d'activation",

    ImportReward: 'Importer une récompense',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    OperatingDays: "Jours d'exploitation",
    From: 'De',
    DiscountStartDate: 'Date de début de remise',
    DiscountEndDate: 'Date de fin de remise',
    ID: 'ID',
    CashValue: 'Valeur en espèces',

    PointsValue: 'Valeur en points',
    LoyaltyProgram: 'Programme de fidélité',
    Identifier: 'Identifiant',
    Action: 'Action',
    ThisRewardsIsCurrentlyFREE: 'Cette récompense est actuellement GRATUITE',
    ReActivateSellingPrice: 'Réactiver un prix de vente ci-dessous ou en ajouter un nouveau',
    AddSellingPrice: 'Ajouter un prix de vente',
    EditSellingPrice: 'Modifier le prix de vente',
    HowDoYouValueYourRewards: 'Comment évaluez-vous vos récompenses ?',
    CostPrice: 'Prix de revient',
    SocialMedia: 'Médias sociaux',
    Title: 'Titre',
    Image: 'Image',
    iOSAppLink: "Lien de l'app iOS",
    AndroidAppLink: "Lien de l'app Android",
    WebLink: 'Lien web',
    AddCustomField: 'Ajouter un champ personnalisé',
    CustomField: 'Champ personnalisé',
    TypeInFieldName: 'Saisir le nom du champ',
    TypeInFieldValue: 'Saisir la valeur du champ',
    SelectCodeType: 'Sélectionner le type de code',
    TypeOfCode: 'Type de code',
    GenericCode: 'Code générique',
    QRCode: 'Code QR',
    BarCode: 'Code-barres',
    URL: 'URL',
    SelectFile: 'Sélectionner un fichier',
    ChooseFile: 'Choisir un fichier',
    DownloadSample: "Télécharger l'exemple (Format accepté : fichiers .xlsx/.csv uniquement)",
    ErrorParsingTheFile: "Erreur lors de l'analyse du fichier",
    SelectStashReward: 'Sélectionnez Récompense Stash',
    RewardHasToBeLinkedToAStashReward: 'La Récompense Doit Être Liée À Une Récompense Stash',
    InventorySource: "Source d'inventaire",
    Limits: 'Limites',
    IssueAMaximumOf: 'Émettre un maximum de',
    RewardsPer: 'Récompenses par',
    Second: 'Seconde',
    Minutes: 'Minutes',
    Hours: 'Heures',
    Days: 'Jours',
    Weeks: 'Semaines',
    Months: 'Mois',
    Month: 'Mois',
    Year: 'Année',
    ALifetimeLimitMustBeSet: 'Une limite à vie doit être définie',
    TheMaximumLimitIs: 'La limite maximale est',
    TheLimitMustBeMoreThan: 'La limite doit être supérieure à',
    DisplayEvenWhenIssuanceLimitIsReached:
      "Afficher même lorsque la limite d'émission est atteinte",
    RewardRedemptionLimit: 'Limite de rachat de récompense',
    LimitRedemptionsTo: 'Limiter les rachats à',
    PleaseFillInTheLimitRedemptionToValue:
      'Veuillez renseigner la valeur de la limite de rédemption',
    PleaseFillInTheRedemptionIntervalUnits:
      'Veuillez renseigner les unités de l’intervalle de rédemption',

    UserLimit: 'Limite utilisateur',
    UserLimitPerPeriod: 'Limite utilisateur par période',
    DisplayEvenWhenLimitIsReached: 'Afficher même lorsque la limite est atteinte',
    ValidityPeriod: 'Période de validité',
    AfterDateOfPurchaseDate: "Après la date d'achat",
    SelectType: 'Sélectionner le type',
    Period: 'PÉRIODE',
    IssuanceDate: "DATE D'ÉMISSION",
    EndOfMonth: 'FIN DU MOIS',
    RedemptionOutcomes: 'Résultats de rachat',
    AddOutcome: 'Ajouter un résultat',
    Online: 'EN LIGNE',
    Offline: 'HORS LIGNE',
    MerchantPIN: 'PIN MARCHAND',
    Pin: 'PIN',
    APIRedemption: 'RACHAT API',
    SetCountdown: 'Définir le compte à rebours',
    SelectGiftingOption: "Sélectionner l'option de cadeau",
    ScheduleLaunch: 'Planifier le lancement',
    MapYourRewardTo: 'Associer votre récompense à',
    Include: 'Inclure',
    SneakPeek: 'Aperçu',
    SelectLoyaltyProgram: 'Veuillez sélectionner votre programme de fidélité',
    PickAudienceList: "Choisir une liste d'audience",
    UploadNewList: 'Télécharger une nouvelle liste',
    AcceptedFormat: 'Format accepté : fichiers .xlsx/.csv uniquement',
    AudienceNotInList: 'Audience non dans la liste ?',
    PleaseSelectAMerchant: 'Veuillez sélectionner un marchand',
    StartDateEndDateRequired: 'Date de début et date de fin requises',
    EndDateCannotBeBeforeStartDate: 'La date de fin ne peut pas être antérieure à la date de début',
    RewardHasToBeLinkedToAnInventoryItem: 'La récompense doit être liée à un article d’inventaire',
    BatchNeedsToBeSelected: 'Le lot doit être sélectionné',
    NumberOfVouchersMustBeGreaterOrEqual1: 'Le nombre de bons doit être ≥ 1',
    VoucherCodesCannotBeEmpty: 'Les codes de bons ne peuvent pas être vides',
    Batches: 'Lots',
    MerchantName: 'Nom du marchand',
    UNASSIGNED_VOUCHER_CODES: 'CODES DE BONS NON ATTRIBUÉS',
    ACTIVE_INVENTORY_BALANCE: 'SOLDE D’INVENTAIRE ACTIF',
    OutOf: 'sur',
    IncludeFromBatch: 'Inclure depuis le lot',
    VoucherCodes: 'Codes de bon',
    IncludeAnotherBatch: 'Inclure un autre lot',
    PrefixForVoucherCode: 'Préfixe pour le code bon',
    LengthOfCode: 'Longueur du code',
    CodeFormat: 'Format du code',
    Total: 'Total',
    PossibleTotalPermutations: 'Nombre total de permutations possibles',
    SelectOption: 'Sélectionner une option',
    RedemptionTypeEditError:
      'Désolé, vous ne pouvez pas modifier le type de rédemption d’une récompense active.',
    EnterCallToActionURL: 'Saisissez l’URL de l’appel à l’action',
    APIEndpoint: 'Point de terminaison API',
    QueryParamsValue: 'Valeur des paramètres de requête',
    BodyParamsValue: 'Valeur des paramètres du corps',
    PleaseSelectRedemptionType: 'Veuillez sélectionner le type de rédemption',
    PleaseSelectAnAPI: 'Veuillez sélectionner une API',
    Key: 'Clé',
    Value: 'Valeur',
    Prefix: 'Préfixe',
    Postfix: 'Suffixe',
    isRequired: 'est requis',
    IDENTIFIER: 'IDENTIFIANT',
    PROGRAM: 'PROGRAMME',
    POINTS: 'POINTS',
    PRICE: 'PRIX',
    LISTING: 'LISTE',
    Exclude: 'Exclure',
    SneakPreview: 'Aperçu en avant-première',

    ValidityAtLeastOneHour: "La validité doit être d'au moins 1 heure",
    ValidFor: 'Valide pour',
    GraceTime: 'Délai de grâce',
    GraceTimeCannotBeNegative: 'Le délai de grâce ne peut pas être négatif',
    Yes: 'Oui',
    No: 'Non',

    RewardInfo: 'Informations sur la récompense',
    RewardMechanics: 'Mécanismes de récompense',
    PendingReward: 'Récompense en attente',
    AddComment: 'Ajouter un commentaire',
    ThisRewardIsPendingApproval:
      'Cette récompense est en attente d’approbation. Tous les commentaires ajoutés apparaîtront ici.',
    ViewAndAddComments: 'Voir et ajouter des commentaires',
    EnterYourCommentHere: 'Saisissez votre commentaire ici',
    DeleteComment: 'Supprimer le commentaire?',
    CommentDeleted: 'Commentaire supprimé',
    CommentsAdded: 'commentaires ajoutés',
    AreYouSureYouWantToDeleteThisComment: 'Êtes-vous sûr de vouloir supprimer ce commentaire',
    ErrorDeletingComment: 'Erreur lors de la suppression du commentaire',
    RewardMustHaveAName: 'La récompense doit avoir un nom',
    AllowedFileTypes: 'Autorisé : .jpg, .png, .svg',
    EitherAniOSOrAndroidOrWebLinkIsRequired: 'Un lien iOS ou Android ou Web est requis',
    Delete: 'Supprimer',
    InsertPhoto: 'Insérer une photo',
    SelectImageType: 'Sélectionner des images png, svg, jpeg ou gif',
    Info: 'Info',
    Audience: 'Audience',
    SelectAudience: 'Sélectionner une audience',
    Review: 'Vérifier',
    Mechanics: 'Mécanismes',
    RewardDetails: 'Détails de la récompense',
    SelectDate: 'Sélectionner une date',
    SelectTime: 'Sélectionner un horaire',

    PleaseSelectYourBrands: 'Veuillez sélectionner vos marques',
    PleaseSelectYourTags: 'Veuillez sélectionner vos tags',
    PleaseSelectYourCategories: 'Veuillez sélectionner vos catégories',
    PleaseSelectYourLabels: 'Veuillez sélectionner vos étiquettes',
    PleaseSelectYourCatalogues: 'Veuillez sélectionner vos catalogues',
    PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',
    TypeInYourRewardNameHere: 'Saisissez le nom de votre récompense ici',
    TypeInYourSubtitleNameHere: 'Saisissez le sous-titre ici',

    EnglishRewardNameRequired: 'Le nom de la récompense en anglais est requis',
    RewardNameRequired: 'Le nom de la récompense est requis',
    StartDateRequired: 'La date de début est requise',
    RewardOwnerRequired: 'Le propriétaire de la récompense est requis',
    UploadedImagesShouldBeSetAsSection:
      'Les images téléchargées doivent être définies comme une section',
    DiscountStartDateCannotBeBlank: 'La date de début de remise ne peut pas être vide',
    DiscountEndDateCannotBeBlank: 'La date de fin de remise ne peut pas être vide',
    DiscountEndDateCannotBeBeforeDiscountStartDate:
      'La date de fin de remise ne peut pas être antérieure à la date de début de remise',
    RewardPartnerRequired: 'Le partenaire de récompense est requis',
    ValidityPeriodMustExtendPastSellingPeriod:
      "La période de validité doit s'étendre au-delà de la période de vente.",
    RewardLimitFieldShouldBePositive: 'Le champ Limite de récompense doit être positif',
    RewardLimitPerPeriodFieldShouldBePositive:
      'Le champ Limite de récompense par période doit être positif',
    RewardLimitPerPeriodUnitsRequired:
      'Les unités de limite de récompense par période sont requises',
    RewardLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Les unités de limite de récompense par période doivent être supérieures à zéro',
    RewardLimitPerPeriodFieldRequired: 'Le champ Limite de récompense par période est requis',
    RewardLimitPerPeriodFieldShouldBeMoreThanZero:
      'Le champ Limite de récompense par période doit être supérieur à zéro',
    UserLimitFieldShouldBePositive: 'Le champ Limite utilisateur doit être positif',
    UserLimitPerPeriodFieldShouldBePositive:
      'Le champ Limite utilisateur par période doit être positif',
    UserLimitPerPeriodUnitsRequired: 'Les unités de limite utilisateur par période sont requises',
    UserLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Les unités de limite utilisateur par période doivent être supérieures à zéro',
    UserLimitPerPeriodFieldRequired: 'Le champ Limite utilisateur par période est requis',
    RedemptionIntervalUnitsOrLimitRedemptionToValueShouldBeMoreThanZero:
      "Les unités d'intervalle de rachat ou la limite de rachat à la valeur doivent être supérieures à zéro",

    ActivationStartDate: "Date d'activation",
    SetActivationStartDate: "Date d'activation set",
    ApproveReward: 'Approuver la récompense',
    SubmitDeletionRequest: 'Soumettre une demande de suppression',
    AreYouSureYouWantToApproveThisReward: 'Êtes-vous sûr de vouloir approuver cette récompense',
    ThisActionCannotBeUndone: 'Cette action ne peut pas être annulée',
    ThisRewardIsPendingApprovalAreYouSureYouWantToDeleteIt:
      "Cette récompense est en attente d'approbation. Êtes-vous sûr de vouloir la supprimer ?",
    OnceTheDeletionIsApprovedThisRewardWillNotBeAvailableAndYouWillNeedToCreateItAgain:
      'Une fois la suppression approuvée, cette récompense ne sera plus disponible et vous devrez la créer à nouveau.',
    SetAs: 'Définir comme',
    Day: 'Jour',
    PERIOD: 'PÉRIODE',
    To: 'à',
    ISSUANCE_DATE: 'DATE D’ÉMISSION',
    END_OF_MONTH: 'FIN DU MOIS',
    ONLINE: 'EN LIGNE',
    OFFLINE: 'HORS LIGNE',
    PIN: 'NIP',
    Every: 'Chaque',
    OpenTimeIsRequired: 'L’heure d’ouverture est obligatoire',
    CloseTimeIsRequired: 'L’heure de fermeture est obligatoire',
    CloseTimeCannotBeBeforeOrSameAsOpenTime:
      'L’heure de fermeture ne peut pas être antérieure ou égale à l’heure d’ouverture',

    RewardOutcomesTable: {
      OutcomeType: 'Type de résultat',
      Value: 'Valeur',
      LoyaltyProgram: 'Programme de fidélité',
      Action: 'Action',
      SetOutcomeValue: 'Définir la valeur du résultat',
      Delete: 'Supprimer'
    }
  },
  [VoucherCodeSetupPageKey]: {
    NoCode: 'Pas de code',
    Single: 'Unique',
    SystemGenerated: 'Généré par le système',
    UserUpload: 'Téléchargement utilisateur',
    Inventory: 'Inventaire',
    Stash: 'Réserve',
    VoucherCodeSetup: 'Configuration du code de bon',
    SelectCodeType: 'Sélectionner le type de code',
    None: 'Aucun'
  },
  [RewardSellingModalKey]: {
    SelectLoyaltyProgram: 'Veuillez sélectionner votre programme de fidélité',
    SelectTier: 'Sélectionner le niveau',
    Cash: 'Espèces',
    PointsRegularPrice: 'Points (prix régulier)',
    PointsDiscountPrice: 'Points (prix réduit)',
    egHundred: 'par ex. 100',
    Optional: 'Optionnel',
    SelectGLAccount: 'Sélectionner le compte GL',
    GLAccountType: 'Type de compte GL',
    GLAccountName: 'Nom du compte GL',
    EitherPriceOrPointsIsRequired: 'Le prix ou les points doivent être renseignés',
    DiscountPriceCannotBeMoreThanRegularPrice:
      'Le prix remisé ne peut pas être supérieur au prix normal',
    DiscountPriceShouldBeAtLeast: 'Le prix remisé doit être au moins de 1',
    Issue: 'Émettre',
    Value: 'Valeur',
    Points: 'Points'
  },
  [StatusTextKey]: {
    active: 'Actif',
    inactive: 'Inactif',
    draft: 'Brouillon',
    processing: 'Traitement',
    pending: 'En attente',
    approved: 'Approuvé',
    scheduled: 'Programmé',
    redeemed: 'Utilisé',
    ended: 'Terminé',
    failed: 'Échoué',
    fail: 'Échec',
    expired: 'Expiré',
    public: 'Public',
    success: 'Succès',
    completed: 'Terminé',
    timeout: 'Délai d’attente',
    system: 'Système',
    CreatingReward: 'Création De Récompense...',
    RewardSubmittedForApproval: 'Récompense Soumise Pour Approbation',
    FailedToCreateReward: 'Échec De La Création De Récompense !',
    RewardApproval: 'Approbation De Récompense...',
    ApprovalSuccess: 'Approbation Réussie...',
    FailedToApprove: 'Échec De L’Approbation !',
    DeactivationRequestSubmittedForApproval: 'Demande De Désactivation Soumise Pour Approbation !',
    DeactivationSuccess: 'Désactivation Réussie...',
    FailedToDeactivate: 'Échec De La Désactivation !',
    RewardDeactivation: 'Désactivation De Récompense...',
    RewardReactivation: 'Réactivation De Récompense...',
    ReactivationSuccess: 'Réactivation Réussie...',
    ReactivationRequestSubmittedForApproval: 'Demande De Réactivation Soumise Pour Approbation !',
    FailedToReactivate: 'Échec De La Réactivation !',
    Processing: 'Traitement...',
    FailedToUpdateReward: 'Échec De La Mise À Jour De La Récompense !',
    ErrorLoadingRewards: 'Erreur Lors Du Chargement Des Récompenses !',
    ErrorLoadingTags: 'Erreur Lors Du Chargement Des Étiquettes !',
    ErrorLoadingBrands: 'Erreur Lors Du Chargement Des Marques !',
    ErrorLoadingAudiences: 'Erreur Lors Du Chargement De La Liste D’Audience !',
    SubmittingData: 'Envoi Des Données...',
    FileUploadSuccess: 'Téléversement Réussi',
    DuplicatingReward: 'Duplication De Récompense...',
    FailedToDuplicate: 'Échec De La Duplication !',
    FailedToLoadData: 'Échec Du Chargement Des Données !',
    CouldNotRetrieveRewards: 'Impossible De Récupérer Les Récompenses !',
    ErrorObtainingPartnerDetails: 'Erreur Lors De L’Obtention Des Détails Du Partenaire !',
    ErrorLoadingMerchants: 'Erreur Lors Du Chargement Des Commerçants !',
    ErrorLoadingLoyaltyList: 'Erreur Lors Du Chargement De La Liste De Fidélité !'
  },

  [RewardModalKey]: {
    CurrentTotalRewardLimit: 'Limite Totale Actuelle De Récompense',
    ReplenishVoucherCodesAndLimits: 'Réapprovisionner Les Codes Et Limites De Bons',
    DepleteVoucherCodesAndLimits: 'Réduire Les Codes Et Limites De Bons',
    Replenish: 'Réapprovisionner',
    Deplete: 'Réduire',
    Depleting: 'Réduction En Cours',
    Replenishing: 'Réapprovisionnement En Cours',
    UploadNewVoucherCodes: 'Téléverser De Nouveaux Codes De Bons',
    ClickOrDragFileToUpload: 'Cliquez Ou Glissez Un Fichier Dans Cette Zone Pour Le Téléverser',
    DepleteMustBeGreaterThanZero: 'La Réduction Doit Être Supérieure À Zéro.',
    DepletingReplenished: 'Réduction Réapprovisionnée',
    SuccessfullyReplenished: 'Réapprovisionné Avec Succès',
    ThereAreDuplicatedCodes: 'Il Y A {{count}} Codes Dupliqués.',
    DownloadDuplicatedCodes: 'Télécharger Les Codes Dupliqués',
    RewardLimitStatus: '{{value}} sur {{total}} limite de récompense',
    ThereAreDepletedCodes: 'Il Y A {{depleted_count}} Codes Épuisés.',
    DownloadDepletedCodes: 'Télécharger Les Codes Épuisés',
    DownloadLogFile: 'Télécharger Le Fichier Journal',
    YouHaveDuplicateVoucherCodes:
      'Vous Avez {{duplicates_count}} Codes De Bons En Double. Veuillez Vérifier Votre Fichier Et Le Téléverser À Nouveau.'
  }
};
